import { render, staticRenderFns } from "./HeadlineMetric.vue?vue&type=template&id=05e165d9&scoped=true"
import script from "./HeadlineMetric.vue?vue&type=script&lang=js"
export * from "./HeadlineMetric.vue?vue&type=script&lang=js"
import style0 from "./HeadlineMetric.vue?vue&type=style&index=0&id=05e165d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e165d9",
  null
  
)

export default component.exports